/* ==========================================================================
   TEERATH — PREMIUM SHOPIFY THEME JS
   Native Shopify AJAX Cart, Dynamic Variant Selector, Wishlist & Drawer System
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initSmoothScroll();
  initHeader();
  initCartDrawer();
  initCartPage();
  initWishlist();
  initMobileMenu();
  initSearchModal();
  initVideoPlayer();
  initProductPage();
  initNewsletter();
  initCollectionFilters();
  initCategorySlider();
  initWishlistSystem();
});

function initSmoothScroll() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  document.documentElement.style.scrollBehavior = 'smooth';
  document.body.style.scrollBehavior = 'smooth';

  if (typeof Lenis === 'undefined') return;

  const lenis = new Lenis({
    duration: 1.05,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    syncTouch: false,
    touchMultiplier: 1.2
  });

  window.teerathLenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  document.querySelectorAll('.cart-drawer, .wishlist-drawer, .search-modal, .js-noscroll').forEach((el) => {
    el.setAttribute('data-lenis-prevent', '');
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href');
    if (!id || id === '#') return;
    const target = document.querySelector(id);
    if (!target) return;
    event.preventDefault();
    lenis.scrollTo(target, { offset: -12, duration: 1.1 });
  });
}

/* 1. Header Scroll Effect */
function initHeader() {
  const header = document.querySelector('.satvik-header-container') || document.querySelector('.header-section-wrapper') || document.getElementById('shopify-section-header');
  if (!header) return;

  const headerGroup = document.querySelector('.shopify-section-group-header-group') || header;

  function syncHeaderHeight() {
    const height = Math.ceil(headerGroup.getBoundingClientRect().height);
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }

  syncHeaderHeight();
  window.addEventListener('resize', syncHeaderHeight);

  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      header.classList.add('is-scrolled');
      document.body.classList.add('header-is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
      document.body.classList.remove('header-is-scrolled');
    }
  }, { passive: true });
}

/* 2. Cart Drawer & Native Shopify AJAX Cart Handler */
function initCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  const openBtns = document.querySelectorAll('.js-open-cart');
  const closeBtns = document.querySelectorAll('.js-close-cart');

  if (!drawer) return;

  function openCart() {
    const mobileDrawer = document.getElementById('MobileNavDrawer');
    const mobileOverlay = document.getElementById('MobileNavOverlay');
    if (mobileDrawer) mobileDrawer.classList.remove('is-active');
    if (mobileOverlay) mobileOverlay.classList.remove('is-active');
    drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    updateCartDrawer();
  }

  function closeCart() {
    drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  closeBtns.forEach(btn => btn.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  updateCartDrawer();

  // Global Native Shopify Quick Add & Buy Now Event Listeners
  document.addEventListener('click', async (e) => {
    const quickAddBtn = e.target.closest('.js-quick-add, .js-add-to-cart-direct');
    if (quickAddBtn) {
      e.preventDefault();
      const variantId = quickAddBtn.dataset.id || quickAddBtn.dataset.variantId;
      if (!variantId) {
        window.location.href = '/collections/all';
        return;
      }

      const originalHtml = quickAddBtn.innerHTML;
      quickAddBtn.innerHTML = 'Adding...';
      try {
        await addItemToCart(variantId, 1);
        openCart();
      } catch (err) {
        console.error('Error adding to Shopify Cart:', err);
        showToast('Please select a valid product variant.');
      } finally {
        quickAddBtn.innerHTML = originalHtml;
      }
    }

    const buyNowBtn = e.target.closest('.js-buy-now, .js-buy-now-direct');
    if (buyNowBtn) {
      e.preventDefault();
      const selected = document.getElementById('SelectedVariantId');
      const variantId = (selected && selected.value) || buyNowBtn.dataset.id || buyNowBtn.dataset.variantId;
      const qtyInput = document.getElementById('ProdQtyInput');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) {
        window.location.href = '/collections/all';
        return;
      }

      const originalHtml = buyNowBtn.innerHTML;
      buyNowBtn.innerHTML = 'Processing...';
      try {
        await addItemToCart(variantId, quantity);
        // if (window.teerathGoKwik && typeof window.teerathGoKwik.checkout === 'function') {
        //   window.teerathGoKwik.checkout();
        // } else {
        //   window.location.href = '/checkout';
        // }
        if (window.teerathAds && typeof window.teerathAds.beginCheckout === 'function') {
          window.teerathAds.beginCheckout();
        }
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === "function") {
          window.gokwikSdk.initCheckout(merchantInfo);
        } else {
          console.error("GoKwik SDK not ready");
        }

      } catch (err) {
        console.error('Error initiating Checkout:', err);
        // if (window.teerathGoKwik && typeof window.teerathGoKwik.checkout === 'function') {
        //   window.teerathGoKwik.checkout();
        // } else {
        //   window.location.href = '/checkout';
        // }
        if (window.teerathAds && typeof window.teerathAds.beginCheckout === 'function') {
          window.teerathAds.beginCheckout();
        }
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === "function") {
          window.gokwikSdk.initCheckout(merchantInfo);
        } else {
          console.error("GoKwik SDK not ready");
        }
      } finally {
        buyNowBtn.innerHTML = originalHtml;
      }
    }
  });

  // Expose openCart globally
  window.openCartDrawer = openCart;
}

/* Toast Notification Utility */
function showToast(message) {
  let toast = document.querySelector('.teerath-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'teerath-toast';
    document.body.appendChild(toast);
  }
  toast.innerHTML = `<span>🪔</span> <div>${message}</div>`;
  toast.classList.add('show');
  setTimeout(() => {
    toast.classList.remove('show');
  }, 3500);
}

/* Native Shopify AJAX Cart API Helpers */
async function addItemToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: parseInt(quantity) }] })
  });

  if (res.ok) {
    await updateCartDrawer();
    showToast('Added sacred offering to your cart!');
    return res.json();
  } else {
    const errorData = await res.json();
    throw new Error(errorData.description || 'Failed to add item to cart.');
  }
}

let currentCartDataItems = [];

async function updateCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    const cartData = await res.json();
    currentCartDataItems = cartData.items || [];

    const itemCount = cartData.item_count || 0;
    const subtotal = (cartData.total_price || 0) / 100.0;

    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = itemCount;
      if (el.classList.contains('nav-cart-badge') || el.classList.contains('satvik-cart-badge')) {
        if (itemCount > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }
    });
    document.querySelectorAll('.js-open-cart').forEach(el => {
      el.setAttribute('aria-label', itemCount ? 'Cart (' + itemCount + ')' : 'Cart');
    });

    // Render Cart Drawer Items List
    const itemsContainer = document.getElementById('CartDrawerItems');
    if (itemsContainer) {
      if (currentCartDataItems.length === 0) {
        itemsContainer.innerHTML = '<div style="text-align:center; padding:3rem 1rem;"><p style="color:var(--color-text-muted); font-size:0.95rem;">Your sacred cart is currently empty.</p><a href="/collections/all" class="btn btn-primary" style="margin-top:1rem; font-size:0.85rem; padding:0.6rem 1.5rem;">Explore Sacred Jals</a></div>';
      } else {
        itemsContainer.innerHTML = currentCartDataItems.map(item => `
          <div class="cart-item" style="display:flex; gap:1rem; align-items:center; border-bottom:1px solid var(--color-border-light); padding-bottom:1rem; margin-bottom:1rem;">
            <div style="width:60px; height:60px; background:var(--color-river-blue-light); border-radius:8px; display:flex; align-items:center; justify-content:center; border:1px solid var(--color-border); overflow:hidden;">
              ${item.featured_image.url ? `<img src="${item.featured_image.url}" alt="${item.title}" style="width:100%; height:100%; object-fit:cover;">` : '<span style="font-size:1.5rem;">🫙</span>'}
            </div>
            <div class="cart-item-info" style="flex:1;">
              <h4 class="cart-item-title" style="font-family:var(--font-heading); font-size:0.95rem; color:var(--color-primary-maroon); margin-bottom:0.25rem;">${item.product_title || item.title}</h4>
              <div class="cart-item-price" style="font-weight:700; color:var(--color-primary-maroon); font-size:0.9rem;">₹${(item.final_price / 100.0).toLocaleString('en-IN')}</div>
              <div class="cart-qty-controls" style="display:inline-flex; border:1px solid var(--color-border); border-radius:4px; margin-top:0.35rem;">
                <button type="button" class="qty-btn" onclick="changeQty('${item.key}', -1)" style="padding:0.2rem 0.5rem;">-</button>
                <input type="text" class="qty-input" value="${item.quantity}" readonly style="width:30px; text-align:center; border:none; font-size:0.85rem;">
                <button type="button" class="qty-btn" onclick="changeQty('${item.key}', 1)" style="padding:0.2rem 0.5rem;">+</button>
              </div>
            </div>
            <button type="button" class="cart-item-remove-btn" onclick="removeItemFromCart('${item.key}')" title="Remove item" style="color:var(--color-text-muted); cursor:pointer; background:none; border:none; font-size:1.1rem;">
              ✕
            </button>
          </div>
        `).join('');
      }
    }

    // Update Subtotal Display
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (subtotalEl) {
      subtotalEl.textContent = `₹${Math.round(subtotal).toLocaleString('en-IN')}`;
    }

    // Free Shipping Progress Bar
    const freeThreshold = 999;
    const freeMsgEl = document.getElementById('FreeShippingMessage');
    const freeFillEl = document.getElementById('FreeShippingFill');
    if (freeMsgEl && freeFillEl) {
      if (subtotal >= freeThreshold || currentCartDataItems.length === 0) {
        freeMsgEl.innerHTML = '🎉 <strong>Congratulations!</strong> You have unlocked <strong>Complimentary Delivery</strong>!';
        freeFillEl.style.width = '100%';
      } else {
        const remaining = freeThreshold - subtotal;
        freeMsgEl.innerHTML = `Add <strong>₹${Math.round(remaining).toLocaleString('en-IN')}</strong> more to unlock <strong>Complimentary Delivery</strong>`;
        const pct = Math.min(100, Math.round((subtotal / freeThreshold) * 100));
        freeFillEl.style.width = `${pct}%`;
      }
    }

  } catch (e) {
    console.error('Error fetching Shopify Cart:', e);
  }
}

window.changeQty = async function (key, delta) {
  const item = currentCartDataItems.find(i => String(i.key) === String(key) || String(i.id) === String(key));
  const currentQty = item ? item.quantity : 1;
  const targetQty = currentQty + delta;

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: Math.max(0, targetQty) })
    });
    if (res.ok) {
      await updateCartDrawer();
      if (document.getElementById('CartPageContent')) {
        window.location.reload();
      }
    }
  } catch (e) {
    console.error('Error changing cart quantity:', e);
  }
};

window.removeItemFromCart = async function (key) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: 0 })
    });
    if (res.ok) {
      await updateCartDrawer();
      if (document.getElementById('CartPageContent')) {
        window.location.reload();
      }
    }
  } catch (e) {
    console.error('Error removing item from cart:', e);
  }
};

/* 2b. Main Cart Page Handler */
function initCartPage() {
  const cartContent = document.getElementById('CartPageContent');
  if (!cartContent) return;

  const handleQuantityChange = async (qtyBtn) => {
    if (qtyBtn.disabled) return;
    qtyBtn.disabled = true;

    const key = qtyBtn.dataset.key;
    const action = qtyBtn.dataset.action;
    const input = cartContent.querySelector(`.js-cart-page-qty-input[data-key="${key}"]`);
    if (!input) {
      qtyBtn.disabled = false;
      return;
    }

    let currentQty = parseInt(input.value, 10) || 1;
    let newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
    if (newQty < 0) newQty = 0;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(key), quantity: newQty })
      });
      if (res.ok) {
        window.location.reload();
      } else {
        qtyBtn.disabled = false;
      }
    } catch (err) {
      console.error('Error updating cart quantity:', err);
      qtyBtn.disabled = false;
    }
  };

  // Delegate click for quantity +/- and remove buttons
  cartContent.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('.js-cart-page-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      await handleQuantityChange(qtyBtn);
      return;
    }

    const removeBtn = e.target.closest('.js-cart-page-remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = removeBtn.dataset.key;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(key), quantity: 0 })
        });
        if (res.ok) {
          window.location.reload();
        }
      } catch (err) {
        console.error('Error removing item from cart:', err);
      }
      return;
    }
  });

  // Delegate change event for quantity inputs
  cartContent.addEventListener('change', async (e) => {
    const input = e.target.closest('.js-cart-page-qty-input');
    if (input) {
      const key = input.dataset.key;
      let newQty = parseInt(input.value, 10);
      if (isNaN(newQty) || newQty < 0) newQty = 0;

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(key), quantity: newQty })
        });
        if (res.ok) {
          window.location.reload();
        }
      } catch (err) {
        console.error('Error updating cart quantity input:', err);
      }
    }
  });
}

/* 3. Wishlist Storage Handler */
function initWishlist() {
  // Delegated to initWishlistSystem in Section 11
}

/* 4. Mobile Navigation Drawer */
function initMobileMenu() {
  const toggle = document.querySelector('.js-mobile-nav-toggle');
  const drawer = document.getElementById('MobileNavDrawer');
  const overlay = document.getElementById('MobileNavOverlay');
  const closeBtn = document.querySelector('.js-close-mobile-nav');

  if (!toggle || !drawer) return;

  function openMenu() {
    drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
  }

  function closeMenu() {
    drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
  }

  toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/* 5. Search Modal Handler */
function initSearchModal() {
  const overlay = document.getElementById('SearchModalOverlay');
  const openBtns = document.querySelectorAll('.js-open-search');
  const closeBtn = document.querySelector('.js-close-search');
  const input = document.getElementById('SearchModalInput');

  if (!overlay) return;

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    overlay.classList.add('is-active');
    if (input) setTimeout(() => input.focus(), 100);
  }));

  if (closeBtn) {
    closeBtn.addEventListener('click', () => overlay.classList.remove('is-active'));
  }

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('is-active');
  });
}

/* 6. Video Story Player Control */
function initVideoPlayer() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-play-video-btn');
    if (btn) {
      const frame = btn.closest('.video-section-frame');
      if (!frame) return;
      const video = frame.querySelector('.js-story-video');
      const overlay = frame.querySelector('.js-video-overlay');

      if (video) {
        if (video.paused) {
          video.play().then(() => {
            if (overlay) overlay.classList.add('is-playing');
            btn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
          }).catch(err => console.log('Video play error:', err));
        } else {
          video.pause();
          if (overlay) overlay.classList.remove('is-playing');
          btn.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" style="margin-left: 3px;"><path d="M8 5v14l11-7z"/></svg>';
        }
      }
    }
  });
}

/* 7. Product Page Logic (Variant Selection & AJAX Form Submit) */
function initProductPage() {
  const mainImg = document.getElementById('MainProductImage');
  const thumbs = document.querySelectorAll('.js-thumb-img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.pdp-thumb').forEach((el) => el.classList.remove('is-active'));
      const wrap = thumb.closest('.pdp-thumb');
      if (wrap) wrap.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full') || thumb.src;
    });
  });

  // Custom Animated Web Dropdown Component Handler
  const customDropdownContainer = document.getElementById('CustomVariantDropdown');
  const customDropdownTrigger = document.getElementById('CustomVariantTrigger');
  const customDropdownTriggerText = document.getElementById('CustomVariantTriggerText');
  const customVariantOptions = document.querySelectorAll('.js-custom-variant-option');
  const hiddenVariantInput = document.getElementById('SelectedVariantId');
  const priceDisplay = document.getElementById('ProductPriceDisplay');

  function updateSelectedVariant(variantId, variantPrice) {
    if (hiddenVariantInput && variantId) {
      hiddenVariantInput.value = variantId;
    }
    if (priceDisplay && variantPrice) {
      priceDisplay.textContent = variantPrice;
    }
    if (variantId) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  }

  if (customDropdownTrigger && customDropdownContainer) {
    customDropdownTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      customDropdownContainer.classList.toggle('is-active');
    });

    customVariantOptions.forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation();
        customVariantOptions.forEach(o => {
          o.classList.remove('is-selected');
          const check = o.querySelector('.custom-dropdown-item-check');
          if (check) check.style.display = 'none';
        });
        opt.classList.add('is-selected');
        const check = opt.querySelector('.custom-dropdown-item-check');
        if (check) check.style.display = 'inline-block';

        const variantId = opt.dataset.variantId;
        const variantPrice = opt.dataset.variantPrice;
        const variantTitle = opt.dataset.variantTitle;

        if (customDropdownTriggerText) {
          customDropdownTriggerText.textContent = `${variantTitle} — ${variantPrice}`;
        }
        updateSelectedVariant(variantId, variantPrice);
        if (typeof window.teerathSetSoldOut === 'function') {
          window.teerathSetSoldOut(opt.getAttribute('data-available') === 'false');
        }
        customDropdownContainer.classList.remove('is-active');
      });
    });

    document.addEventListener('click', (e) => {
      if (!customDropdownContainer.contains(e.target)) {
        customDropdownContainer.classList.remove('is-active');
      }
    });
  }

  // Product Form AJAX Submit Handler
  const productForm = document.querySelector('.js-shopify-product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantIdInput = productForm.querySelector('input[name="id"]');
      const qtyInput = productForm.querySelector('input[name="quantity"]');
      const submitBtn = productForm.querySelector('button[type="submit"]');

      if (!variantIdInput || !variantIdInput.value) {
        showToast('Please select a valid variant.');
        return;
      }

      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) submitBtn.innerHTML = 'Adding...';

      try {
        await addItemToCart(variantIdInput.value, qtyInput ? qtyInput.value : 1);
        if (window.openCartDrawer) window.openCartDrawer();
      } catch (err) {
        showToast(err.message || 'Error adding item to cart.');
      } finally {
        if (submitBtn) submitBtn.innerHTML = originalText;
      }
    });
  }
}

/* 8. Newsletter Form Submit Handler */
function initNewsletter() {
  const forms = document.querySelectorAll('.js-newsletter-form');
  forms.forEach(form => {
    form.addEventListener('submit', function () {
      const fields = form.querySelector('.newsletter-fields-wrap');
      const msg = form.querySelector('.newsletter-success-msg');
      if (fields && msg) {
        fields.style.display = 'none';
        msg.style.setProperty('display', 'block', 'important');
      }
    });
  });
}

/* 9. Collection Page Filters & Sort Handler */
function initCollectionFilters() {
  const sortBySelect = document.getElementById('SortBy');
  if (sortBySelect) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortBySelect.value = currentSort;
    }

    sortBySelect.addEventListener('change', (e) => {
      const value = e.target.value;
      urlParams.set('sort_by', value);
      window.location.search = urlParams.toString();
    });
  }
}

/* 10. Category Slider Carousel Arrows Handler */
function initCategorySlider() {
  const track = document.querySelector('.js-cat-track');
  const prevBtn = document.querySelector('.js-cat-prev');
  const nextBtn = document.querySelector('.js-cat-next');

  if (!track) return;

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -260, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: 260, behavior: 'smooth' });
    });
  }
}

/* 11. Unified Wishlist System */
const WISHLIST_STORAGE_KEY = 'teerath_wishlist_items';

function getWishlistItems() {
  try {
    const data = localStorage.getItem(WISHLIST_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
}

function saveWishlistItems(items) {
  try {
    localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
  } catch (e) { }
  updateWishlistBadgeCount();
  syncWishlistButtons();
  renderWishlistPage();
  renderWishlistDrawer();
}

function updateWishlistBadgeCount() {
  const items = getWishlistItems();
  const count = items.length;

  document.querySelectorAll('.js-wishlist-count').forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-flex' : 'none';
  });

  document.querySelectorAll('.js-wishlist-count-drawer').forEach(badge => {
    badge.textContent = count;
  });
}

function wishlistItemIdFromButton(btn) {
  const raw = btn.dataset.productId || btn.dataset.id || btn.dataset.productTitle || '';
  return String(raw).trim();
}

function wishlistTitleFromButton(btn) {
  return String(btn.dataset.productTitle || '').trim().toLowerCase();
}

function wishlistItemMatchesButton(item, btn) {
  const id = wishlistItemIdFromButton(btn);
  const title = wishlistTitleFromButton(btn);
  const itemId = String(item.id || item.productId || '').trim();
  const itemTitle = String(item.title || '').trim().toLowerCase();
  if (id && itemId && id === itemId) return true;
  if (title && itemTitle && title === itemTitle) return true;
  return false;
}

function paintWishlistHeart(btn, isActive) {
  btn.classList.toggle('active', !!isActive);
  btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  btn.querySelectorAll('svg').forEach((svg) => {
    svg.style.fill = isActive ? '#C58B2B' : 'none';
    svg.style.stroke = isActive ? '#C58B2B' : '#2D120E';
    svg.setAttribute('fill', isActive ? '#C58B2B' : 'none');
    svg.querySelectorAll('path').forEach((path) => {
      path.style.fill = isActive ? '#C58B2B' : 'none';
      path.setAttribute('fill', isActive ? '#C58B2B' : 'none');
    });
  });
}

function syncWishlistButtons() {
  const items = getWishlistItems();

  document.querySelectorAll('.js-toggle-wishlist').forEach(btn => {
    const isActive = items.some((item) => wishlistItemMatchesButton(item, btn));
    paintWishlistHeart(btn, isActive);
  });
}

function escapeWishlistHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function renderWishlistPage() {
  const grid = document.getElementById('WishlistGrid') || document.getElementById('WishlistGridFallback');
  const emptyState = document.getElementById('WishlistEmptyState');
  const countText = document.querySelector('.js-wishlist-page-count');
  const countFallback = document.getElementById('WishlistPageCountFallback');
  const clearBtn = document.querySelector('.js-clear-wishlist');

  if (!grid) return;

  const items = getWishlistItems();

  if (countText) {
    if (items.length === 0) {
      countText.textContent = 'Your wishlist is currently empty.';
    } else {
      countText.textContent = `Showing ${items.length} Saved Devotional Offering${items.length > 1 ? 's' : ''}`;
    }
  }

  if (countFallback) {
    countFallback.textContent = String(items.length);
  }

  if (clearBtn) {
    clearBtn.style.display = items.length > 0 ? 'inline-block' : 'none';
  }

  if (items.length === 0) {
    grid.style.display = 'none';
    if (emptyState) emptyState.style.display = 'block';
  } else {
    if (emptyState) emptyState.style.display = 'none';
    grid.style.display = 'grid';
    grid.innerHTML = items.map(item => `
      <article class="product-card hp-product-card">
        <div class="product-media hp-product-media">
          <button type="button" class="wishlist-btn-card hp-wishlist js-toggle-wishlist active"
                  data-product-id="${item.id}"
                  data-product-title="${escapeWishlistHtml(item.title)}"
                  data-product-price="${item.price}"
                  data-product-url="${item.url}"
                  data-product-image="${item.image || ''}"
                  data-variant-id="${item.variantId || ''}"
                  aria-label="Remove from wishlist">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.78-8.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </button>
          <a href="${item.url || '/collections/all'}" class="product-img-link">
            ${item.image ? `<img class="main-img" src="${item.image}" alt="${escapeWishlistHtml(item.title)}" loading="lazy">` : ''}
          </a>
        </div>
        <div class="product-content hp-product-body">
          <h3 class="product-title hp-product-title">
            <a href="${item.url || '/collections/all'}">${escapeWishlistHtml(item.title)}</a>
          </h3>
          <div class="hp-product-price">
            <span class="product-price-row"><span class="price-current">₹${item.price}</span></span>
          </div>
          <div class="product-card-actions hp-product-actions">
            <button type="button" class="btn btn-secondary js-quick-add product-btn-add hp-btn-add" data-id="${item.variantId || ''}" data-variant-id="${item.variantId || ''}">Add to Cart</button>
            <button type="button" class="btn btn-primary js-buy-now product-btn-buy hp-btn-buy" data-id="${item.variantId || ''}" data-variant-id="${item.variantId || ''}">Buy Now</button>
          </div>
        </div>
      </article>
    `).join('');
  }
}

window.clearAllWishlist = function () {
  saveWishlistItems([]);
  showToast('Cleared all items from your wishlist.');
};

function renderWishlistDrawer() {
  const itemsContainer = document.getElementById('WishlistDrawerItems');
  if (!itemsContainer) return;

  const items = getWishlistItems();
  if (items.length === 0) {
    itemsContainer.innerHTML = '<div style="text-align:center; padding:3rem 1rem;"><p style="color:var(--color-text-muted); font-size:0.95rem;">Your sacred wishlist is currently empty.</p><a href="/collections/all" class="btn btn-primary" style="margin-top:1rem; font-size:0.85rem; padding:0.6rem 1.5rem;">Explore Offerings</a></div>';
  } else {
    itemsContainer.innerHTML = items.map(item => `
      <div class="cart-item" style="display:flex; gap:1rem; align-items:center; border-bottom:1px solid var(--color-border-light); padding-bottom:1rem; margin-bottom:1rem;">
        <div style="width:60px; height:60px; background:var(--color-gold-light); border-radius:8px; display:flex; align-items:center; justify-content:center; border:1px solid var(--color-border); overflow:hidden;">
          ${item.image ? `<img src="${item.image}" alt="${escapeWishlistHtml(item.title)}" style="width:100%; height:100%; object-fit:cover;">` : '<span style="font-size:1.5rem;">🫙</span>'}
        </div>
        <div class="cart-item-info" style="flex:1;">
          <h4 class="cart-item-title" style="font-family:var(--font-heading); font-size:0.95rem; color:var(--color-primary-maroon); margin-bottom:0.25rem;">${escapeWishlistHtml(item.title)}</h4>
          <div class="cart-item-price" style="font-weight:700; color:var(--color-primary-maroon); font-size:0.9rem;">₹${item.price}</div>
        </div>
        <button type="button" class="js-toggle-wishlist active" data-product-id="${item.id}" title="Remove from wishlist" style="color:var(--color-primary-maroon); cursor:pointer; background:none; border:none; font-size:1.2rem;">
          ✕
        </button>
      </div>
    `).join('');
  }
}

function initWishlistSystem() {
  try {
    localStorage.removeItem('teerath_wishlist_ids');
  } catch (e) { }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-toggle-wishlist');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const id = wishlistItemIdFromButton(btn);
      if (!id) return;

      let items = getWishlistItems();
      const wasSaved = items.some((item) => wishlistItemMatchesButton(item, btn));

      if (wasSaved) {
        items = items.filter((item) => !wishlistItemMatchesButton(item, btn));
        showToast('Removed item from your wishlist');
      } else {
        items.push({
          id,
          title: btn.dataset.productTitle || 'Sacred Offering',
          price: btn.dataset.productPrice || '0',
          url: btn.dataset.productUrl || '/collections/all',
          image: btn.dataset.productImage || '',
          variantId: btn.dataset.variantId || ''
        });
        showToast('Saved to your wishlist');
      }

      saveWishlistItems(items);
      try { btn.blur(); } catch (err) { }
      return;
    }

    const clearBtn = e.target.closest('.js-clear-wishlist, .js-clear-wishlist-drawer');
    if (clearBtn) {
      e.preventDefault();
      saveWishlistItems([]);
      showToast('Cleared all items from your wishlist.');
    }

    if (e.target.closest('.js-close-wishlist') || e.target.id === 'WishlistDrawerOverlay') {
      const drawer = document.getElementById('WishlistDrawer');
      const overlay = document.getElementById('WishlistDrawerOverlay');
      if (drawer) drawer.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
    }
  });

  updateWishlistBadgeCount();
  syncWishlistButtons();
  try { renderWishlistPage(); } catch (err) { }
  try { renderWishlistDrawer(); } catch (err) { }
}
